<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="main_head">
            <div class="main_head_left">
              <div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_student_no" placeholder="请输入" size></el-input>
                  <span>学号:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_name" placeholder="请输入" size></el-input>
                  <span>姓名:</span>
                </div>
                <div class="input_parent">
                  <el-date-picker class="input input_daterange" unlink-panels v-model="where_year" value-format="yyyy"
                    type="monthrange"></el-date-picker>
                  <span>入学年份:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_education_status" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in eduStatusOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>深造状态:</span>
                </div>
              </div>

              <div v-show="queryMoreShowFlag">
                <div>
                  <div class="input_parent">
                    <el-select class="input" v-model="where_status" placeholder="请选择" multiple collapse-tags>
                      <el-option v-for="item in workStatusOptions" :key="item" :value="item"></el-option>
                    </el-select>
                    <span>工作状态:</span>
                  </div>
                  <div class="input_parent">
                    <el-select class="input" v-model="where_is_email" placeholder="请选择">
                      <el-option v-for="item in num2Options" :key="item" :value="item"></el-option>
                    </el-select>
                    <span>邮箱是否激活:</span>
                  </div>
                  <div class="input_parent">
                    <el-select class="input" v-model="where_is_account" placeholder="请选择">
                      <el-option v-for="item in num2Options" :key="item" :value="item"></el-option>
                    </el-select>
                    <span>帐号是否激活:</span>
                  </div>
                </div>
                <div>
                  <div class="input_parent">
                    <el-select class="input" v-model="where_programme" placeholder="请选择" multiple collapse-tags>
                      <el-option v-for="item in programmeOptions" :key="item" :value="item"></el-option>
                    </el-select>
                    <span>专业:</span>
                  </div>
                  <div class="input_parent">
                    <el-input class="input" v-model="where_division" placeholder="请输入" size></el-input>
                    <span>学部:</span>
                  </div>
                  <div class="input_parent">
                    <el-date-picker class="input input_daterange" unlink-panels v-model="where_date_of_birth"
                      value-format="yyyy" type="monthrange"></el-date-picker>
                    <span>出生年份:</span>
                  </div>
                  <div class="input_parent">
                    <el-select class="input" v-model="where_gender" placeholder="请选择">
                      <el-option v-for="item in genderOptions" :key="item" :value="item"></el-option>
                    </el-select>
                    <span>性别:</span>
                  </div>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_region" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in regionOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>国家地区:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_id_card_number" placeholder="请输入" size></el-input>
                  <span>身份证号:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_admission_category" placeholder="请输入" size></el-input>
                  <span>招生类型:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_honours_classification" placeholder="请输入" size></el-input>
                  <span>荣誉分类:</span>
                </div>
                <div>
                  <div class="input_parent">
                    <el-date-picker class="input input_daterange" unlink-panels v-model="where_graduation_year"
                      value-format="yyyy" type="monthrange"></el-date-picker>
                    <span>毕业年份:</span>
                  </div>
                  <div class="input_parent">
                    <el-input class="input" v-model="where_mobile_phone" placeholder="请输入" size></el-input>
                    <span>联系电话:</span>
                  </div>
                  <div class="input_parent">
                    <el-input class="input" v-model="where_alumni_email" placeholder="请输入" size></el-input>
                    <span>校友邮箱:</span>
                  </div>
                  <div class="input_parent">
                    <el-input class="input" v-model="where_active_email" placeholder="请输入" size></el-input>
                    <span>常用邮箱:</span>
                  </div>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_wechat" placeholder="请输入" size></el-input>
                  <span>微信:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_navtive_province" placeholder="请输入" size></el-input>
                  <span>籍贯-省份:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_navtive_city" placeholder="请输入" size></el-input>
                  <span>籍贯-城市:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_origin_place" placeholder="请输入" size></el-input>
                  <span>生源地:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_origin_high_school" placeholder="请输入" size></el-input>
                  <span>生源高中:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_label" placeholder="请输入" size></el-input>
                  <span>标签:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_welfare_gymnasium_setting" placeholder="请选择" multiple
                    collapse-tags>
                    <el-option v-for="item in welfareGymnasiumSettingOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>校友福利:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_alumni_type" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in alumniTypeOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>校友类别:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_alumni_status" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in alumniStatusOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>校友状态:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_member_type" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in membershipCategoryOptions" :label="item.label" :key="item.value"
                      :value="item.value"></el-option>
                  </el-select>
                  <span>会员类别:</span>
                </div>
                <div class="input_parent">
                  <el-cascader class="input input_daterange" v-model="where_job_region" :options="jobRegionOptions"
                    :props="{ expandTrigger: 'hover' }" @change="handleRegionChange" clearable filterable></el-cascader>
                  <span>工作所在地:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_job_organization" placeholder="请输入" size></el-input>
                  <span>工作单位名称:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_job_unit_property" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in unitOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>工作单位性质:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_job_type" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in jobTypeOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>工作行业类型:</span>
                </div>

                <div class="input_parent">
                  <el-input class="input" v-model="where_job_position" placeholder="请输入" size></el-input>
                  <span>工作职位:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_job_pay" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in payOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>工作薪酬范围:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_job_registered_address" placeholder="请输入" size></el-input>
                  <span>工作公司注册地:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_job_employees" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in employeesOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>工作雇员人数:</span>
                </div>
                <div class="input_parent">
                  <el-select class="input" v-model="where_job_turnover" placeholder="请选择" multiple collapse-tags>
                    <el-option v-for="item in turnoverOptions" :key="item" :value="item"></el-option>
                  </el-select>
                  <span>工作年营业额:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_job_freelance" placeholder="请输入" size></el-input>
                  <span>工作从事何种自由职业:</span>
                </div>
                <div class="input_parent">
                  <el-cascader class="input input_daterange" v-model="where_education_region" :options="jobRegionOptions"
                    :props="{ expandTrigger: 'hover' }" @change="handleEduRegionChange" clearable
                    filterable></el-cascader>
                  <span>深造所在地:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_education_school" placeholder="请输入" size></el-input>
                  <span>深造院校名称:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_education_programme" placeholder="请输入"></el-input>
                  <span>深造院校专业:</span>
                </div>
                <div class="input_parent input_parent_Max">
                  <el-date-picker class="input input_daterange" v-model="where_education_graduation_year"
                    value-format="yyyy" style="width: 69%" type="monthrange"></el-date-picker>
                  <span>深造毕业年份:</span>
                </div>
                <div class="input_parent">
                  <el-input class="input" v-model="where_education_other" placeholder="请输入" size></el-input>
                  <span>深造其他:</span>
                </div>
              </div>
            </div>
            <div class="main_head_right">
              <el-button type="primary" @click="query()">查询</el-button>
              <el-button @click="reset()">重置</el-button>
              <el-button type="text" @click="queryMoreShow()">{{
                queryMoreShowTitle
              }}</el-button>
              <span v-bind:class="[
                    queryMoreShowFlag ? 'el-icon-arrow-up' : 'el-icon-arrow-down',
                  ]" @click="queryMoreShow()"></span>
            </div>
          </div>
          <div style="clear: both"></div>
          <div style="margin-top: 10px">
            <el-dropdown @command="handleDialogCommand" placement="bottom-start">
              <el-button>
                <i class="el-icon-s-operation el-icon--left"></i> 批量操作
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="exportInfoDialog">导出选中信息</el-dropdown-item>
                <el-dropdown-item command="exportAisLatestInfoDialog">导出查询列表</el-dropdown-item>
                <el-dropdown-item command="exportSelectInfoDialog">导出查询列表选中信息</el-dropdown-item>
                <!-- <el-dropdown-item>批量替换信息</el-dropdown-item>
                <el-dropdown-item>批量写入信息</el-dropdown-item>
                <el-dropdown-item>合并信息</el-dropdown-item>-->
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown @command="handleDialogCommand" placement="bottom-start">
              <el-button>
                更多操作
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="showExcelDialog">通过Excel文件导入</el-dropdown-item>
                <el-dropdown-item command="showSiDialog">从SI系统中导入</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <i class="el-icon-setting setTabBabel" style="margin-top: 10px" @click="showSetTabBabelDrawer()"></i>
          </div>
          <div class="selectTitle" v-if="selectSize > 0">
            <span class="el-icon-info" style="color: #2383e0"></span>
            <span style="margin-left: 10px">已选择</span>
            <span class="selectTitleNum">{{ selectSize }}</span>
            <span>个校友</span>
            <el-button type="text" class="selectTitleClear" @click="cleanTable()">清空</el-button>
          </div>

          <el-table v-loading="tableLoading" ref="multipleTable" :data="tableData" @sort-change="changeTableSort"
            tooltip-effect="dark" style="width: 100%" @row-click="toUserDetails" @selection-change="handleSelectionChange"
            :default-sort="{ prop: 'date', order: 'descending' }" row-key="id" default-expand-all
            :tree-props="{ children: 'son' }">
            <el-table-column type="selection" min-width="1"></el-table-column>
            <el-table-column prop="student_no" label="学号" min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="name_cn" label="中文姓名" min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="name_en" label="英文姓名" min-width="13" sortable="custom"></el-table-column>
            <el-table-column prop="year" v-if="checkList.indexOf('入学年份') > -1" label="入学年份" min-width="13"
              sortable="custom"></el-table-column>
            <el-table-column prop="education_status" v-if="checkList.indexOf('深造状态') > -1" label="深造状态" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="status" v-if="checkList.indexOf('工作状态') > -1" label="工作状态" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="is_email" v-if="checkList.indexOf('邮箱是否激活') > -1" label="邮箱是否激活" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="is_account" v-if="checkList.indexOf('帐号是否激活') > -1" label="帐号是否激活" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="programme" v-if="checkList.indexOf('专业') > -1" label="专业" min-width="16"
              sortable="custom"></el-table-column>
            <el-table-column prop="division" v-if="checkList.indexOf('学部') > -1" label="学部" min-width="16"
              sortable="custom"></el-table-column>
            <el-table-column prop="date_of_birth" v-if="checkList.indexOf('出生年份') > -1" label="出生年份" min-width="13"
              sortable="custom"></el-table-column>
            <el-table-column prop="gender" v-if="checkList.indexOf('性别') > -1" label="性别" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="region" v-if="checkList.indexOf('国家地区') > -1" label="国家地区" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="id_card_number" v-if="checkList.indexOf('身份证号') > -1" label="身份证号" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="admission_category" v-if="checkList.indexOf('招生类型') > -1" label="招生类型" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="honours_classification" v-if="checkList.indexOf('荣誉分类') > -1" label="荣誉分类"
              min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="graduation_year" v-if="checkList.indexOf('毕业年份') > -1" label="毕业年份" min-width="13"
              sortable="custom"></el-table-column>
            <el-table-column prop="mobile_phone" v-if="checkList.indexOf('联系电话') > -1" label="联系电话" min-width="13"
              sortable="custom"></el-table-column>
            <el-table-column prop="alumni_email" v-if="checkList.indexOf('校友邮箱') > -1" label="校友邮箱" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="active_email" v-if="checkList.indexOf('常用邮箱') > -1" label="常用邮箱" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="wechat" v-if="checkList.indexOf('微信') > -1" label="微信" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="navtive_province" v-if="checkList.indexOf('籍贯-省份') > -1" label="籍贯-省份" min-width="14"
              sortable="custom"></el-table-column>
            <el-table-column prop="navtive_city" v-if="checkList.indexOf('籍贯-城市') > -1" label="籍贯-城市" min-width="14"
              sortable="custom"></el-table-column>
            <el-table-column prop="origin_place" v-if="checkList.indexOf('生源地') > -1" label="生源地" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="origin_high_school" v-if="checkList.indexOf('生源高中') > -1" label="生源高中" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="label" v-if="checkList.indexOf('标签') > -1" label="标签" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="welfare_gymnasium_setting" v-if="checkList.indexOf('校友福利') > -1" label="校友福利"
              min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="alumni_type" v-if="checkList.indexOf('校友类别') > -1" label="校友类别" min-width="13"
              sortable="custom"></el-table-column>
            <el-table-column prop="member_type" v-if="checkList.indexOf('会员类别') > -1" label="会员类别" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="is_bachelors_masters" v-if="checkList.indexOf('是否本硕连读') > -1" label="是否本硕连读"
              min-width="12"></el-table-column>
            <el-table-column prop="alumni_status" v-if="checkList.indexOf('校友状态') > -1" label="校友状态" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="job_location" v-if="checkList.indexOf('工作所在地') > -1" label="工作所在地" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="job_organization" v-if="checkList.indexOf('工作单位名称') > -1" label="工作单位名称" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="job_unit_property" v-if="checkList.indexOf('工作单位性质') > -1" label="工作单位性质"
              min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="job_type" v-if="checkList.indexOf('工作行业类型') > -1" label="工作行业类型" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="job_position" v-if="checkList.indexOf('工作职位') > -1" label="工作职位" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="job_pay" v-if="checkList.indexOf('工作薪酬范围') > -1" label="工作薪酬范围" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="job_registered_address" v-if="checkList.indexOf('工作公司注册地') > -1" label="工作公司注册地"
              min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="job_employees" v-if="checkList.indexOf('工作雇员人数') > -1" label="工作雇员人数" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="job_turnover" v-if="checkList.indexOf('工作年营业额') > -1" label="工作年营业额" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="job_freelance" v-if="checkList.indexOf('工作从事何种自由职业') > -1" label="工作从事何种自由职业"
              min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="edu_location" v-if="checkList.indexOf('深造所在地') > -1" label="深造所在地" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="education_school" v-if="checkList.indexOf('深造院校名称') > -1" label="深造院校名称" min-width="12"
              sortable="custom"></el-table-column>
            <el-table-column prop="education_programme" v-if="checkList.indexOf('深造院校专业') > -1" label="深造院校专业"
              min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="education_graduation_year" v-if="checkList.indexOf('深造毕业年份') > -1" label="深造毕业年份"
              min-width="12" sortable="custom"></el-table-column>
            <el-table-column prop="education_other" v-if="checkList.indexOf('深造其他') > -1" label="深造其他" min-width="12"
              sortable="custom"></el-table-column>
          </el-table>
          <div class="elPaginationDiv">
            <el-pagination :key="elementui_page_key" class="elPagination" background layout="prev, pager, next"
              :page-size="pageMaxSize" :page-count="pageCount" :current-page="currentPage"
              @current-change="currentChange"></el-pagination>
            <span class="paginationPageNum">第{{ thispageNum }}条，总共{{ recordCount }}条</span>
          </div>
        </el-main>
        <import-excel-dialog ref="_importExcalDialog"></import-excel-dialog>
        <import-si-dialog ref="_importSiDialog" @toOpLogList="toOpLogList"></import-si-dialog>
        <export-info-dialog ref="_exportInfoDialog" @getExportSelectInfo="getExportSelectInfo"></export-info-dialog>
        <export-ais-latest-info-dialog ref="_exportAisLatestInfoDialog"></export-ais-latest-info-dialog>
        <users-table-label-drawer ref="_usersTableLabelDrawer"
          @toBackCheckList="backCheckList"></users-table-label-drawer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as ResUtils from "@/utils/resUtils.js";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import * as CRegion from "@/utils/constant_region.js";

import leftMeun from "@/components/layout/leftMeun";
import headerLayout from "@/components/layout/headerLayout";
import headRight from "@/components/layout/headRight";
import importExcelDialog from "@/components/dialog/importExcelDialog";
import importSiDialog from "@/components/dialog/importSiDialog";
import exportInfoDialog from "@/components/dialog/exportInfoDialog";
import exportAisLatestInfoDialog from "@/components/dialog/exportAisLatestInfoDialog";
import usersTableLabelDrawer from "@/components/drawer/usersTableLabelDrawer";

var multipleSelectionMap = new Map(); // 多页选中数组总数

// table 筛选器
function ScreenOptions(value) {
  this.text = value;
  this.value = value;
}
export default {
  components: {
    leftMeun,
    headerLayout,
    headRight,
    importExcelDialog,
    importSiDialog,
    exportInfoDialog,
    exportAisLatestInfoDialog,
    usersTableLabelDrawer,
  },
  data() {
    return {
      tableLoading: false,
      meunItem: null,
      meunTitle: "校友基本信息列表",
      queryMoreShowFlag: false,
      exportAisLatestInfoRequest: false,
      exportSelectInfoRequest: false,
      exportSelectFieldArr: '',
      queryMoreShowTitle: "展开",
      timeOutTimer: "",
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      pageCount: 0, // 所有页数
      selectSize: 0,
      otherPageSelectSize: 0, //其他页选中的数量
      recordCount: 0,
      thispageNum: "1-" + LIST_PAGE_MAX_SIZE,

      currentPage: 1,
      order: "",
      where_student_no: "",
      where_name: "",
      where_year: [],
      where_education_status: [],
      where_status: [],
      where_is_email: "",
      where_is_account: "",
      where_programme: [],
      where_division: "",
      where_date_of_birth: [],
      where_gender: "",
      where_region: [],
      where_id_card_number: "",
      where_admission_category: "",
      where_honours_classification: "",
      where_graduation_year: [],
      where_mobile_phone: "",
      where_alumni_email: "",
      where_active_email: "",
      where_wechat: "",
      where_navtive_province: "",
      where_navtive_city: "",
      where_origin_place: "",
      where_origin_high_school: "",
      where_label: "",
      where_alumni_type: [],
      where_welfare_gymnasium_setting: [],
      where_alumni_status: [],
      where_member_type: [],
      where_job_region: [],
      where_job_organization_nation: '',
      where_job_organization_province: '',
      where_job_organization_city: '',
      where_job_organization: '',
      where_job_unit_property: '',
      where_job_type: '',
      where_job_position: '',
      where_job_pay: '',
      where_job_registered_address: '',
      where_job_employees: '',
      where_job_turnover: '',
      where_job_freelance: '',
      where_education_region: [],
      where_education_nation: '',
      where_education_province: '',
      where_education_city: '',
      where_education_school: '',
      where_education_programme: '',
      where_education_graduation_year: '',
      where_education_other: '',

      eduStatusOptions: Constant.edu_status_options,
      workStatusOptions: Constant.work_status_options,
      genderOptions: Constant.gender_options,
      num2Options: Constant.num_2_options,
      programmeOptions: [],
      alumniTypeOptions: [],
      alumniStatusOptions: [],
      membershipCategoryOptions: Constant.membership_category_options,
      regionOptions: [],
      welfareGymnasiumSettingOptions: [],

      jobRegionOptions: JSON.parse(localStorage.getItem("options_region")),
      unitOptions: Constant.unit_options,
      payOptions: Constant.pay_options,
      jobTypeOptions: Constant.job_type_options,
      turnoverOptions: Constant.turnover_options,
      employeesOptions: Constant.employees_options,
      eduStatusFilters: Constant.edu_status_filters,
      workStatusFilters: Constant.work_status_filters,
      activateFilters: Constant.activate_filters,
      genderFilters: Constant.gender_filters,
      regionFilters: Constant.region_filters,
      programmeFilters: [],
      divisionFilters: [],
      admissionFilters: [],
      honoursFilters: [],

      tableData: [],
      multipleSelection: [], // 单页选中数组
      // 表格显示字段
      checkList: Constant.users_table_lable,
    };
  },
  mounted() {
    var that = this;
    document.onkeydown = function (e) {
      const keyCode = event.keyCode
        ? event.keyCode
        : event.which
          ? event.which
          : event.charCode;
      // 回车键查询
      if (keyCode == 13) that.query();
    };
  },
  created() {
    this.elementui_page_key++;
    CRegion.regionPutAllOptions(this.jobRegionOptions);
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      Api.verifyApi(CApi.api_getAisInfo, (verify) => {
        if (verify) {
          this.getAisInfos();
          this.getRegionOptions();
          this.getProgrammeOptions();
          this.getWelfareGymnasiumSettingOptions();
          this.getAlumniTypeOptions();
          this.getAlumniStatusOptions();
        }
      });
    },
    showSetTabBabelDrawer() {
      this.$nextTick(() => {
        this.$refs._usersTableLabelDrawer.show(this.checkList);
      });
    },
    // 导出校友信息
    exportAisLatestInfo() {
      if (this.recordCount == 0) {
        this.$message.error("列表无数据，无法导出");
        return;
      }
      this.$nextTick(() => {
        this.$refs._exportAisLatestInfoDialog.show(
          this.checkList,
          this.order,
          this.where_student_no,
          this.where_name,
          this.where_year,
          this.where_education_status,
          this.where_status,
          this.where_is_email,
          this.where_is_account,
          this.where_programme,
          this.where_division,
          this.where_date_of_birth,
          this.where_gender,
          this.where_region,
          this.where_id_card_number,
          this.where_admission_category,
          this.where_honours_classification,
          this.where_graduation_year,
          this.where_mobile_phone,
          this.where_alumni_email,
          this.where_active_email,
          this.where_wechat,
          this.where_navtive_province,
          this.where_navtive_city,
          this.where_origin_place,
          this.where_origin_high_school,
          this.where_label,
          this.where_welfare_gymnasium_setting,
          this.where_alumni_type,
          this.where_member_type,
          this.where_alumni_status,
          this.where_job_organization_nation,
          this.where_job_organization_province,
          this.where_job_organization_city,
          this.where_job_organization,
          this.where_job_unit_property,
          this.where_job_type,
          this.where_job_position,
          this.where_job_pay,
          this.where_job_registered_address,
          this.where_job_employees,
          this.where_job_turnover,
          this.where_job_freelance,
          this.where_education_nation,
          this.where_education_province,
          this.where_education_city,
          this.where_education_school,
          this.where_education_programme,
          this.where_education_graduation_year,
          this.where_education_other
        );
      });
    },
    // 选择列表显示字段
    backCheckList(list) {
      this.checkList = list;
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.otherPageSelectSize += this.multipleSelection.length;
      multipleSelectionMap.set(this.currentPage, this.multipleSelection);
      console.log(multipleSelectionMap);

      this.otherPageSelectSize = 0;
      var that = this;
      multipleSelectionMap.forEach(function (key, value, index) {
        if (value != val) {
          that.otherPageSelectSize += key.length;
        }
      });
      this.currentPage = val;
      this.getAisInfos();
    },
    // 列表选中监听
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.setShowBatchBtnState(this.multipleSelection.length);
    },
    // 查看学生详情 details
    toUserDetails(row, column, event) {
      Api.verifyApi(CApi.api_getAisInfoById, (verify) => {
        if (verify) {
          this.meunItem.userid = row.id;
          console.log(row);
          localStorage.setItem("meunItem", JSON.stringify(this.meunItem));
          this.$router.push({
            path: "/data/user-details",
            query: { id: row.id },
          });
        }
      });
    },
    // 批量操作弹窗
    handleDialogCommand(command) {
      multipleSelectionMap.set(this.currentPage, this.multipleSelection);
      let _this = this;
      switch (command) {
        case "showExcelDialog": // 弹窗->导入excel
          Api.verifyApi(CApi.api_updateStudentByExcel, (verify) => {
            if (verify) {
              _this.$nextTick(() => {
                _this.$refs._importExcalDialog.init();
              });
            }
          });
          break;
        case "showSiDialog": // 弹窗->导入si
          _this.$nextTick(() => {
            _this.$refs._importSiDialog.init();
          });
          break;
        case "exportInfoDialog": // 弹窗->导出选中校友
          Api.verifyApi(CApi.api_downloadXlsx, (verify) => {
            if (verify) {
              if (this.selectSize == 0) {
                _this.$message.error("至少选中一个校友");
                return;
              }
              _this.$nextTick(() => {
                var userIds = _this.getUserIds();
                _this.$refs._exportInfoDialog.init(userIds);
              });
            }
          });
          break;
        case "exportAisLatestInfoDialog":
          Api.verifyApi(CApi.api_exportAisLatestInfo, (verify) => {
            if (verify) {
              this.exportAisLatestInfoRequest = true;
              this.getAisInfos();
            }
          });
          break;
        case "exportSelectInfoDialog":
          Api.verifyApi(CApi.api_exportSelectInfo, (verify) => {
            if (verify) {
              _this.$nextTick(() => {
                _this.$refs._exportInfoDialog.show();
              });
            }
          });
          break;
      }
    },
    getExportSelectInfo(val) {
      this.exportSelectFieldArr = val
      this.exportSelectInfoRequest = true;
      this.getAisInfos();
    },
    exportSelectInfo() {
      if (this.recordCount == 0) {
        this.$message.error("列表无数据，无法导出");
        return;
      }
      this.$nextTick(() => {
        this.$refs._exportAisLatestInfoDialog.showSelectInfo(
          this.exportSelectFieldArr,
          this.order,
          this.where_student_no,
          this.where_name,
          this.where_year,
          this.where_education_status,
          this.where_status,
          this.where_is_email,
          this.where_is_account,
          this.where_programme,
          this.where_division,
          this.where_date_of_birth,
          this.where_gender,
          this.where_region,
          this.where_id_card_number,
          this.where_admission_category,
          this.where_honours_classification,
          this.where_graduation_year,
          this.where_mobile_phone,
          this.where_alumni_email,
          this.where_active_email,
          this.where_wechat,
          this.where_navtive_province,
          this.where_navtive_city,
          this.where_origin_place,
          this.where_origin_high_school,
          this.where_label,
          this.where_welfare_gymnasium_setting,
          this.where_alumni_type,
          this.where_member_type,
          this.where_alumni_status,
          this.where_job_organization_nation,
          this.where_job_organization_province,
          this.where_job_organization_city,
          this.where_job_organization,
          this.where_job_unit_property,
          this.where_job_type,
          this.where_job_position,
          this.where_job_pay,
          this.where_job_registered_address,
          this.where_job_employees,
          this.where_job_turnover,
          this.where_job_freelance,
          this.where_education_nation,
          this.where_education_province,
          this.where_education_city,
          this.where_education_school,
          this.where_education_programme,
          this.where_education_graduation_year,
          this.where_education_other
        );
      });
    },
    // 排序
    changeTableSort(column) {
      if ("job_location" == column.prop) {
        this.order = StrUtils.getLocationPropOrder(column, "job_organization");
      } else if ("edu_location" == column.prop) {
        this.order = StrUtils.getLocationPropOrder(column, "education");
      } else {
        this.order = StrUtils.getPropOrder(column);
      }
      this.query();
    },
    // 服务端获取数据
    getAisInfos: function () {
      this.tableLoading = true;
      this.$api
        .getAisInfo({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,

          order: this.order,
          where_student_no: this.where_student_no,
          where_name: this.where_name,

          where_year:
            this.where_year == undefined || this.where_year.length == 0
              ? ""
              : this.where_year[0] + "-" + this.where_year[1],
          where_date_of_birth:
            this.where_date_of_birth == undefined ||
              this.where_date_of_birth.length == 0
              ? ""
              : this.where_date_of_birth[0] + "-" + this.where_date_of_birth[1],
          where_graduation_year:
            this.where_graduation_year == undefined ||
              this.where_graduation_year.length == 0
              ? ""
              : this.where_graduation_year[0] +
              "-" +
              this.where_graduation_year[1],

          where_is_email: StrUtils.isEmpty(this.where_is_email)
            ? ""
            : this.where_is_email === this.num2Options[0]
              ? "1"
              : "0",
          where_is_account: StrUtils.isEmpty(this.where_is_account)
            ? ""
            : this.where_is_account === this.num2Options[0]
              ? "1"
              : "0",
          where_gender: StrUtils.isEmpty(this.where_gender)
            ? ""
            : this.where_gender === this.genderOptions[0]
              ? "M"
              : "F",

          where_education_status: StrUtils.replaceFields(
            this.where_education_status.toString()
          ),
          where_programme: StrUtils.replaceFields(
            this.where_programme.toString()
          ),
          where_status: StrUtils.replaceFields(this.where_status.toString()),
          where_region: StrUtils.replaceFields(this.where_region.toString()),
          where_alumni_type: StrUtils.replaceFields(
            this.where_alumni_type.toString()
          ),
          where_welfare_gymnasium_setting: StrUtils.replaceFields(
            this.where_welfare_gymnasium_setting.toString()
          ),
          where_alumni_status: StrUtils.replaceFields(
            this.where_alumni_status.toString()
          ),
          where_member_type: StrUtils.replaceFields(
            this.where_member_type.toString()
          ),
          where_division: this.where_division,
          where_id_card_number: this.where_id_card_number,
          where_admission_category: this.where_admission_category,
          where_honours_classification: this.where_honours_classification,
          where_mobile_phone: this.where_mobile_phone,
          where_alumni_email: this.where_alumni_email,
          where_active_email: this.where_active_email,
          where_wechat: this.where_wechat,
          where_navtive_province: this.where_navtive_province,
          where_navtive_city: this.where_navtive_city,
          where_origin_place: this.where_origin_place,
          where_origin_high_school: this.where_origin_high_school,
          where_label: this.where_label,
          where_job_organization_nation: this.where_job_organization_nation,
          where_job_organization_province: this.where_job_organization_province,
          where_job_organization_city: this.where_job_organization_city,
          where_job_organization: this.where_job_organization,
          where_job_unit_property: StrUtils.replaceFields(
            this.where_job_unit_property.toString()
          ),
          where_job_type: StrUtils.replaceFields(
            this.where_job_type.toString()
          ),
          where_job_position: this.where_job_position,
          where_job_pay: this.where_job_pay,
          where_job_registered_address: this.where_job_registered_address,
          where_job_employees: StrUtils.replaceFields(
            this.where_job_employees.toString()
          ),
          where_job_turnover: StrUtils.replaceFields(
            this.where_job_turnover.toString()
          ),
          where_job_freelance: this.where_job_freelance,
          where_education_nation: this.where_education_nation,
          where_education_province: this.where_education_province,
          where_education_city: this.where_education_city,
          where_education_school: this.where_education_school,
          where_education_programme: this.where_education_programme,
          where_education_other: this.where_education_other,
          where_education_graduation_year:
            this.where_education_graduation_year == undefined ||
              this.where_education_graduation_year.length == 0
              ? ""
              : this.where_education_graduation_year[0] +
              "-" +
              this.where_education_graduation_year[1],
        })
        .then(({ data }) => {
          this.recordCount = data.Data.recordCount;
          var currentPage = data.Data.currentPage;
          var startIndex = (currentPage - 1) * this.pageMaxSize + 1;
          var endIndex = startIndex + this.pageMaxSize - 1;
          if (endIndex > this.recordCount) {
            endIndex = this.recordCount;
          }
          this.thispageNum = startIndex + "-" + endIndex;
          this.pageCount = data.Data.pageCount;
          this.tableData = data.Data.model;
          this.timeOutTimer = setTimeout(this.toggleRowSelectionn, 10);
          console.log(this.tableData);
          this.tableData.forEach((tData) => {

            tData.job_location = StrUtils.getUserJobLocation(tData);
            tData.edu_location = StrUtils.getEduLocationArray(tData);

            tData.gender = StrUtils.gender(tData.gender);
            tData.is_email = StrUtils.isActivate(tData.is_email);
            tData.is_account = StrUtils.isActivate(tData.is_account);
            tData.is_bachelors_masters = StrUtils.yesOrNo(
              tData.is_bachelors_masters
            );
            if (StrUtils.isEmpty(tData.education_status)) {
              tData.education_status = "无";
            }
            if (tData.son.length > 0) {
              tData.son.forEach((sonData) => {
                sonData.gender = StrUtils.gender(sonData.gender);
                sonData.is_email = StrUtils.isActivate(sonData.is_email);
                sonData.is_account = StrUtils.isActivate(sonData.is_account);
                sonData.is_bachelors_masters = StrUtils.yesOrNo(
                  sonData.is_bachelors_masters
                );
                if (StrUtils.isEmpty(sonData.education_status)) {
                  sonData.education_status = "无";
                }
              });
            }
          });
          this.tableLoading = false;
          if (this.exportAisLatestInfoRequest) {
            this.exportAisLatestInfo();
          }
          if (this.exportSelectInfoRequest) {
            this.exportSelectInfo();
          }
          this.exportSelectInfoRequest = false;
          this.exportAisLatestInfoRequest = false;
        })
        .catch(({ error }) => {
          this.tableLoading = false;
          this.exportSelectInfoRequest = false;
          this.exportAisLatestInfoRequest = false;
          if (error != undefined) {
            console.log(error);
          }
        });
    },
    getRegionOptions: function () {
      this.$api
        .getColumnValue({
          token: localStorage.getItem("token"),
          field: "region",
        })
        .then(({ data }) => {
          this.regionOptions = data.Data.region;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 获取专业
    getProgrammeOptions: function () {
      this.$api
        .getColumnValue({
          token: localStorage.getItem("token"),
          field: "programme",
        })
        .then(({ data }) => {
          this.programmeOptions = data.Data.programme;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 获取校友福利列表
    getWelfareGymnasiumSettingOptions: function () {
      this.$api
        .bindAisInfoFieldArr({
          // token: localStorage.getItem('token'),
          field: "welfare_gymnasium_setting",
        })
        .then(({ data }) => {
          this.welfareGymnasiumSettingOptions =
            data.Data.welfare_gymnasium_setting;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },

    // 获取校友类别
    getAlumniTypeOptions() {
      this.$api
        .bindAisInfoFieldArr({ field: "alumni_type" })
        .then(({ data }) => {
          this.alumniTypeOptions = data.Data.alumni_type;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 获取校友状态
    getAlumniStatusOptions() {
      this.$api
        .bindAisInfoFieldArr({ field: "alumni_status" })
        .then(({ data }) => {
          this.alumniStatusOptions = data.Data.alumni_status;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 恢复勾选已选中
    toggleRowSelectionn() {
      if (multipleSelectionMap.size == 0) return;
      var array = multipleSelectionMap.get(this.currentPage);
      if (array == undefined || array.length == 0) return;
      var arr = JSON.parse(JSON.stringify(array));
      this.tableData.forEach((tData) => {
        arr.forEach((tData1) => {
          if (tData.id === tData1.id) {
            this.$refs.multipleTable.toggleRowSelection(tData, true);
          }
        });
      });
    },
    // 批量操作显示状态修改
    setShowBatchBtnState(size) {
      this.selectSize = size + this.otherPageSelectSize;
    },
    // 获取选中的用户id 数组
    getUserIds: function () {
      var userIds = [];
      multipleSelectionMap.forEach(function (key, value, index) {
        key.forEach((user) => {
          userIds.push(user.id);
        });
      });
      return userIds;
    },
    // 查询
    query: function () {
      this.currentPage = 1;
      this.getAisInfos();
    },
    // 搜索重置
    reset: function () {
      this.$refs.multipleTable.clearFilter();
      multipleSelectionMap.clear();

      this.order = "";
      this.where_student_no = "";
      this.where_name = "";
      this.where_year = [];
      this.where_education_status = "";
      this.where_status = "";
      this.where_is_email = "";
      this.where_is_account = "";
      this.where_programme = "";
      this.where_division = "";
      this.where_date_of_birth = [];
      this.where_gender = "";
      this.where_region = "";
      this.where_id_card_number = "";
      this.where_admission_category = "";
      this.where_honours_classification = "";
      this.where_graduation_year = [];
      this.where_mobile_phone = "";
      this.where_alumni_email = "";
      this.where_active_email = "";
      this.where_wechat = "";
      this.where_navtive_province = "";
      this.where_navtive_city = "";
      this.where_origin_place = "";
      this.where_origin_high_school = "";
      this.where_label = "";
      this.where_alumni_type = [];
      this.where_alumni_status = [];
      this.where_member_type = [];
      this.where_welfare_gymnasium_setting = [];
      this.where_job_region = [];
      this.where_job_organization_nation = '';
      this.where_job_organization_province = '';
      this.where_job_organization_city = '';
      this.where_job_organization = '';
      this.where_job_unit_property = '';
      this.where_job_type = '';
      this.where_job_position = '';
      this.where_job_pay = '';
      this.where_job_registered_address = '';
      this.where_job_employees = '';
      this.where_job_turnover = '';
      this.where_job_freelance = '';
      this.where_education_region = [];
      this.where_education_nation = '';
      this.where_education_province = '';
      this.where_education_city = '';
      this.where_education_school = '';
      this.where_education_programme = '';
      this.where_education_graduation_year = '';
      this.where_education_other = '';

      this.otherPageSelectSize = 0;
      this.exportAisLatestInfoRequest = false;
      this.exportSelectInfoRequest = false;
      this.setShowBatchBtnState(0);
      this.query();
    },
    queryMoreShow() {
      this.queryMoreShowFlag = !this.queryMoreShowFlag;
      this.queryMoreShowTitle = this.queryMoreShowFlag ? "收起" : "展开";
    },
    //清空已选表格
    cleanTable: function () {
      multipleSelectionMap.clear();
      this.otherPageSelectSize = 0;
      this.setShowBatchBtnState(0);
      this.$refs.multipleTable.clearSelection();
    },
    // 前往操作日志列表
    toOpLogList() {
      this.$refs._leftMeun.toOpLog();
    },
    // 工作地区选择
    handleRegionChange(value) {
      this.where_job_organization_nation = value[0];
      this.where_job_organization_province = value[1];
      this.where_job_organization_city = value[2];
    },
    // 深造地区选择
    handleEduRegionChange(value) {
      this.where_education_nation = value[0];
      this.where_education_province = value[1];
      this.where_education_city = value[2];
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeOutTimer);
  },
};
</script>

<style lang="less" scoped>
.main {
  margin: 10px 20px;
  background-color: #fff;
  border-radius: 5px;
}

.main_head {
  width: 100%;
  float: left;
}

.main_head_left {
  margin-left: -20px;
  width: 85%;
  float: left;
}

.selectTitle {
  padding-left: 10px;
  margin-top: 15px;
  background-color: #eff9fe;
  border-radius: 3px;
  border: 1px solid #2383e0;
  height: 40px;
  line-height: 40px;
}

.selectTitleNum {
  color: #2383e0;
}

.selectTitleClear {
  color: #2383e0;
  margin-left: 20px;
  cursor: hand;
}
</style>

<style lang="less">
.el-date-editor--monthrange.el-input,
.el-date-editor--monthrange.el-input__inner {
  width: 55%;
}

.el-table__row--level-1 .el-checkbox {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataMgr/listUsers.vue